import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import { CgProfile } from "react-icons/cg";
import { IoMdLogOut } from "react-icons/io";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
const isDevMode = process.env.REACT_APP_MODE?.toLowerCase() === 'dev';
const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #ffff;
`;

const SidebarNav = styled.nav`
  background: ${(props) => (props.$isDevMode ? "#294a28" : "#15171c")};
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  transition: 350ms;
  z-index: 10;

  &.left-0 {
    left: 0;
  }

  &.left-100 {
    left: -100%;
  }
`;

const SidebarWrap = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: ${(props) => (props.$isDevMode ? "#294a28" : "#1a1a1d")};
`;


const Sidebar = ({ menuList, change }) => {
  const [sidebar, setSidebar] = useState(true);

  const showSidebar = () => {
    setSidebar(!sidebar); // Toggling the boolean value
    change(sidebar); // Pass the boolean directly
  };

  const user = useSelector(selectCurrentUser);
  const flattenMenus = (items = []) => items.flatMap(item => [item, ...flattenMenus(item.child || [])]);
  const menuEntries = flattenMenus(menuList);
  const showThemeLink = menuEntries.some(item => String(item.uri || '').startsWith('/designs')) && !menuEntries.some(item => item.uri === '/designs/themes');

  // console.log(sidebar, "sidebar");
  return (
    <>
      <Navbar expand="lg" className="bg-danger text-white">
        <Container fluid className="px-3">
          <Navbar.Brand href="/">Grace Super Market</Navbar.Brand>
          <Nav.Link href="#" onClick={showSidebar}>
            <FaIcons.FaBars /> Menu
          </Nav.Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              {Number(user?.userType) === 0 && [1, 2, 10].includes(Number(user?.userRole)) && (
                <>
                  <Nav.Link as={Link} to="/admin/gofrugal-offline" className="text-white">Offline delivery sync</Nav.Link>
                  <Nav.Link as={Link} to="/admin/settings/elite-handoffs" className="text-white">Elite handoffs</Nav.Link>
                </>
              )}
              <Navbar.Text className="mx-2 d-flex align-items-center text-white">
                <CgProfile className="me-1" /> {user.name}
              </Navbar.Text>
              <Nav.Link
                className="d-flex align-items-center text-white"
                href="/admin/logout"
              >
                <IoMdLogOut className="me-1" /> Logout
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <IconContext.Provider value={{ color: "#fff" }}>
        <SidebarNav $isDevMode={isDevMode} className={sidebar ? "left-0" : "left-100"}>
          <SidebarWrap $isDevMode={isDevMode}>
            <NavIcon to="#">
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            {showThemeLink && <Nav.Link as={Link} to="/admin/designs/themes?platform=2&page=1" className="text-white px-4 py-3">Themes &amp; publishing</Nav.Link>}
            {menuList.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </>
  );
};

export default Sidebar;

